import { useEffect, useCallback } from 'react'
import { boot, shutdown, update, onUnreadCountChange } from '@intercom/messenger-js-sdk'
import { useAppSelector } from '@app.raytd.com/store'
import { selectLoggedInUser } from '@app.raytd.com/store'

export const IntercomSetup = () => {
  const appId = import.meta.env.VITE_INTERCOM_APP_ID as string | undefined
  const user = useAppSelector(selectLoggedInUser)

  const fetchUserHash = useCallback(async (): Promise<string | undefined> => {
    try {
      const res = await fetch('/api/v1/intercom/hash', { credentials: 'include' })
      if (!res.ok) return undefined
      const json = await res.json()
      return json?.userHash as string | undefined
    } catch {
      return undefined
    }
  }, [])

  useEffect(() => {
    if (!appId) return
    if (!user?.id) return

    let didUnmount = false

    ;(async () => {
      const user_hash = await fetchUserHash()
      if (didUnmount) return

      // Use current timestamp for created_at since user entity doesn't have this field
      const created_at = Math.floor(Date.now() / 1000)

      boot({
        app_id: appId,
        user_id: String(user.id),
        email: user.email,
        name: user.name,
        created_at,
        user_hash, // undefined until BE hash endpoint is live
        hide_default_launcher: true,
        custom_launcher_selector: '#support-link',
      })

      onUnreadCountChange((unreadCount: number) => {
        update({ hide_default_launcher: unreadCount === 0 })
      })
    })()

    return () => {
      didUnmount = true
      shutdown()
    }
  }, [appId, user, fetchUserHash])

  return null
}

